/*
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2023-05-05 15:58:12
 */
import { createApp, ComponentCustomProperties, App as VueApp } from 'vue'
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $aMap: any // Map类
    $map: any // 地图对象
    $mouseTool: any,
    $viewer:any //cesium 地图
  }
}
let root: ComponentCustomProperties
let app = null as any

export function createInstance (App: any): VueApp {
  app = createApp(App)
  root = app.config.globalProperties as ComponentCustomProperties
  return app
}

export function getRoot (): ComponentCustomProperties {
  return root
}

export function getApp (): VueApp {
  return app
}
